const hpInfoStore = {
    state: {
        host: '',
        hpCd: '',
        instNo: '',
        lang: '',
        hosNm: '',
        hpPhone: '',
        hpEmail: '',
    },
    mutations: {
        getHost: function (state, host) {
            state.host = host;
        },
        getHpCd: function (state, hpCd) {
            state.hpCd = hpCd;
        },
        getInstNo: function (state, instNo) {
            state.instNo = instNo;
        },
        getLang: function (state, lang) {
            state.lang = lang;
        },
        getHosNm: function (state, hosNm) {
            state.HosNm = hosNm;
        },
        getHpPhone: function (state, hpPhone) {
            state.hpPhone = hpPhone;
        },
        getHpEmail: function (state, hpEmail) {
            state.hpEmail = hpEmail;
        }
    }
};

export default hpInfoStore;